import type { FaqItem } from '../types/content';

export const faqItems: FaqItem[] = [
  {
    question: '¿CÓMO RECIBO EL MATERIAL DESPUÉS DE COMPRAR?',
    answer: [
      'Al finalizar la compra recibirás un enlace de descarga inmediata en tu correo electrónico.',
      'Accede al instante desde cualquier dispositivo: móvil, tablet u ordenador. Sin esperas ni envíos físicos.'
    ]
  },
  {
    question: '¿ES UN ÚNICO PAGO O UNA SUSCRIPCIÓN?',
    answer: ['Pago único. Sin cuotas mensuales. Sin sorpresas. Pagas una vez y el material es tuyo para siempre.']
  },
  {
    question: '¿CUÁL ES LA DIFERENCIA ENTRE LAS DOS VERSIONES?',
    answer: [
      'Ambas incluyen los 5 tomos y los 5 bonos.',
      'El Kit de Ejecución añade el Mapa de Pista (50 esquemas con consigna, progresión y corrección) y el Programador 12 Meses (calendario de temporada completo de septiembre a junio). Por 5€ más tienes la temporada entera planificada.'
    ]
  },
  {
    question: '¿LOS EJERCICIOS SIRVEN PARA DIFERENTES NIVELES?',
    answer: [
      'Sí. Todo el contenido está organizado con progresiones y adaptaciones por nivel, desde alumnos principiantes hasta intermedios y avanzados. Incluye orientaciones específicas para grupos con niveles mixtos.'
    ]
  },
  {
    question: '¿ME SIRVE SI ESTOY EMPEZANDO COMO MONITOR?',
    answer: [
      'Sí, es especialmente útil si estás empezando porque te da la estructura metodológica que normalmente solo se adquiere con años de experiencia. Te ahorra el ensayo y error.'
    ]
  },
  {
    question: '¿ES UN CURSO EN VÍDEO?',
    answer: [
      'No. Es un sistema en formato PDF de alta calidad, optimizado para consultar desde el móvil en pista. No hay vídeos que ver ni plataforma de cursos. Abres, consultas y ejecutas.'
    ]
  },
  {
    question: '¿ES SOLO PARA MONITORES O TAMBIÉN PARA DIRECTORES DE ESCUELA?',
    answer: [
      'Sirve para ambos. Los monitores lo usan para preparar sus clases y progresar a sus alumnos. Los directores de escuela lo utilizan como base metodológica común para todo su equipo de monitores.'
    ]
  },
  {
    question: '¿CUÁNDO VOY A NOTAR RESULTADOS EN MIS CLASES?',
    answer: [
      'La mayoría de monitores notan la diferencia en la primera semana. Desde la primera sesión que preparas con el sistema ya sientes la diferencia en el tiempo que tardas y en la claridad con la que entras a pista.'
    ]
  },
  {
    question: '¿QUÉ PASA EXACTAMENTE SI PIDO LA DEVOLUCIÓN?',
    answer: [
      'Nos escribes a nuestro correo de contacto dentro de los 14 días siguientes a la compra. Te devolvemos el importe completo en menos de 24 horas. Sin formularios, sin preguntas, sin explicaciones.'
    ]
  }
];
